/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DailyChargingSuccessRateDto } from "./DailyChargingSuccessRateDto";
import {
    DailyChargingSuccessRateDtoFromJSON,
    DailyChargingSuccessRateDtoFromJSONTyped,
    DailyChargingSuccessRateDtoToJSON,
} from "./DailyChargingSuccessRateDto";

/**
 *
 * @export
 * @interface ChargingSuccessRateTrendResponse
 */
export interface ChargingSuccessRateTrendResponse {
    /**
     * Array of daily charging success rate data points for the specified period
     * @type {Array<DailyChargingSuccessRateDto>}
     * @memberof ChargingSuccessRateTrendResponse
     */
    dailyTrends?: Array<DailyChargingSuccessRateDto>;
}

/**
 * Check if a given object implements the ChargingSuccessRateTrendResponse interface.
 */
export function instanceOfChargingSuccessRateTrendResponse(
    value: object,
): value is ChargingSuccessRateTrendResponse {
    return true;
}

export function ChargingSuccessRateTrendResponseFromJSON(
    json: any,
): ChargingSuccessRateTrendResponse {
    return ChargingSuccessRateTrendResponseFromJSONTyped(json, false);
}

export function ChargingSuccessRateTrendResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ChargingSuccessRateTrendResponse {
    if (json == null) {
        return json;
    }
    return {
        dailyTrends:
            json["dailyTrends"] == null
                ? undefined
                : (json["dailyTrends"] as Array<any>).map(
                      DailyChargingSuccessRateDtoFromJSON,
                  ),
    };
}

export function ChargingSuccessRateTrendResponseToJSON(
    value?: ChargingSuccessRateTrendResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        dailyTrends:
            value["dailyTrends"] == null
                ? undefined
                : (value["dailyTrends"] as Array<any>).map(
                      DailyChargingSuccessRateDtoToJSON,
                  ),
    };
}
